// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SlKBHhUaMkA3tfHgKkJ7{pointer-events:none;width:100%;height:100%;z-index:var(--zIndex-UI_100);position:absolute;top:0;left:0}.YQW8tuEiTU9dyddCvNTi{pointer-events:auto}.OatxJ3H1HEewWpeA_3P5{pointer-events:auto;border:1px solid var(--border-neutral-default);border-radius:6px;justify-content:center;align-items:center;display:flex}.oB3RmESDoPsM7zYqHB2o{width:100%;height:100%;z-index:var(--zIndex-BASE_99);border-radius:6px;justify-content:center;align-items:center;display:flex;position:relative;top:0;left:0}.zIPg1XNJDApNdue8kJtH{background:var(--blue-10);border:2px solid var(--action-contained-primary-normal)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropZoneWrapper": `SlKBHhUaMkA3tfHgKkJ7`,
	"dragging": `YQW8tuEiTU9dyddCvNTi`,
	"dropZoneVisible": `OatxJ3H1HEewWpeA_3P5`,
	"dropZone": `oB3RmESDoPsM7zYqHB2o`,
	"overlaying": `zIPg1XNJDApNdue8kJtH`
};
export default ___CSS_LOADER_EXPORT___;
